


























































import Vue from 'vue'
import { defineComponent, ref, watch, computed } from '@vue/composition-api'
import { MessageBox, Message } from 'element-ui'
import { http } from '@/api'
import { tabCurrent, tabName } from '@/assets/tab'
import { project } from '@/assets/project'
import { parseCodeValid } from '@/assets/util'

const empty = {
  label: '',
  name: '',
  code: 'function yourFunctionName () {}'
}
type NodeUtils = typeof empty

export default defineComponent({
  name: 'global-utils',
  props: {
    show: Boolean
  },
  setup (props, ctx) {
    const showDialog = ref(false)
    const list = ref([])
    const dialogForm = ref({})
    const selected = computed(() => project.componentUmd.map(x => x.label))
    const handleEdit = (item: NodeUtils) => {
      handleAddUmd(item)
    }
    const handleAddUmd = (item?: NodeUtils) => {
      if (item) {
        dialogForm.value = { ...item }
      } else {
        dialogForm.value = { ...empty }
      }
      showDialog.value = true
    }
    const handleDelete = async (item: NodeUtils, i: number) => {
      await MessageBox.confirm('确定要删除吗？')
      await http.post('component/utilsSave', { ...item, delete: true }, { successMessage: '删除成功' })
      list.value.splice(i, 1)
    }
    const confirm = () => {
      // @ts-ignore
      ctx.refs.form.validate((valid: boolean) => {
        if (valid) {
          http.post('component/utilsSave', {
            ...dialogForm.value,
            userName: Vue.prototype.$native.name
          }, { successMessage: '操作成功' }).then(() => {
            getList()
            showDialog.value = false
          })
        }
      })
    }
    const getList = () => {
      http.get('component/list', { type: 'utils' }).then(res => {
        list.value = res.data
      })
    }
    watch(() => props.show, val => {
      if (val) {
        getList()
      }
    })
    // const stop = watch(() => tabCurrent.tab1, cur => {
    //   if (cur === tabName.globalUtils) {
    //     getList()
    //     stop()
    //   }
    // })
    const handleAdd = async (item: NodeUtils) => {
      const { ok, value, msg } = parseCodeValid(project.utils)
      if (ok) {
        if (value![item.name]) {
          Message.info('该函数在 全局 utils 中已存在')
        } else {
          project.utils = project.utils.replace('return {', `return {\n    ${item.name}: ${item.code},`)
          Message.success(`添加成功，调用方式：$$global.utils.${item.name}`)
        }
        ctx.emit('hide')
      } else {
        Message.error(msg)
      }
    }
    return {
      showDialog,
      dialogForm,
      amdRequire: window.require,
      dialogFormRules: {
        label: [
          { required: true, message: '请输入', trigger: 'blur' },
          { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      list,
      selected,
      handleEdit,
      handleAddUmd,
      handleDelete,
      confirm,
      handleAdd
    }
  }
})
